import React, { useState } from 'react';
import { Box, Grid, Button, FormControlLabel, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import PropTypes from 'prop-types';
import { deviceColumnOptions } from 'utils/constants';

const EditDeviceColumnsVisibilityDialog = ({ onClose, onSubmit, data, columeData }) => {
    const [columns, setColumns] = useState(data);
    const handleChange = (e) => {
        setColumns({
            ...columns,
            [e.target.name]: e.target.checked
        });
    };
    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '18px' }}>Edit Device Order Columns</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <Grid container>
                        {columeData.map((column, key) => (
                            <Grid item xs={4} key={key}>
                                <FormControlLabel
                                    control={
                                        <Checkbox name={column.column_name} checked={columns[column.column_name]} onChange={handleChange} />
                                    }
                                    label={column.header_name}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="outlined" onClick={() => onSubmit(columns)}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

EditDeviceColumnsVisibilityDialog.propTypes = {
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    data: PropTypes.object,
    columeData: PropTypes.array
};

export default EditDeviceColumnsVisibilityDialog;
